import { Skeleton } from "@/components/ui/skeleton";
import { Progress } from "@/components/ui/progress";
import { GlassCard } from "@/components/GlassCard";
import { MotionStatusRing } from "@/components/MotionStatusRing";
import { useLanguage } from "@/i18n/LanguageContext";

const HeroSkeleton = () => (
  <div className="flex items-center gap-5">
    <Skeleton className="h-[148px] w-[148px] rounded-full bg-white/10" />
    <div className="flex-1 space-y-3">
      <Skeleton className="h-4 w-24 bg-white/10" />
      <Skeleton className="h-3 w-full bg-white/10" />
      <Skeleton className="h-3 w-2/3 bg-white/10" />
    </div>
  </div>
);

export const HeroStatusCard = ({ stats, loading }) => {
  const { t } = useLanguage();

  if (loading) {
    return (
      <GlassCard glow className="p-5">
        <HeroSkeleton />
      </GlassCard>
    );
  }

  const done = stats.today_has_activity;
  return (
    <GlassCard glow className="p-5">
      <div className="flex items-center gap-5">
        <MotionStatusRing pct={stats.weekly_progress_pct}>
          <span className="text-3xl font-semibold tracking-tight font-heading [font-variant-numeric:tabular-nums]">
            {stats.today_minutes}
          </span>
          <span className="text-[11px] text-[hsl(var(--muted-foreground))] mt-0.5">
            {t("dashboard.minToday")}
          </span>
        </MotionStatusRing>
        <div className="flex-1 min-w-0">
          <p
            data-testid="dashboard-today-status"
            className={
              done
                ? "text-sm font-semibold text-emerald-300"
                : "text-sm font-semibold text-cyan-300"
            }
          >
            {done ? t("dashboard.inMotion") : t("dashboard.ready")}
          </p>
          <p className="mt-1 text-xs text-[hsl(var(--muted-foreground))]">
            {t("dashboard.weeklyGoal")} · {stats.weekly_minutes} / {stats.weekly_goal}{" "}
            {t("common.min")}
          </p>
          <div data-testid="dashboard-weekly-goal-progress" className="mt-3">
            <Progress value={stats.weekly_progress_pct} className="h-2 bg-white/10" />
          </div>
          <p className="mt-2 text-[11px] text-[hsl(var(--muted-foreground))] [font-variant-numeric:tabular-nums]">
            {t("dashboard.pctOfGoal", { pct: stats.weekly_progress_pct })}
          </p>
        </div>
      </div>
    </GlassCard>
  );
};
